import { render } from "./CustomerShippingAddress.vue?vue&type=template&id=5c4c8c2e"
import script from "./CustomerShippingAddress.vue?vue&type=script&lang=js"
export * from "./CustomerShippingAddress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__